import { createFileRoute } from "@tanstack/react-router";
import { TestesDevPage } from "@/paginas/pg_dev/dev-testes";

export const Route = createFileRoute("/_authenticated/dev-testes")({
  head: () => ({
    meta: [
      { title: "Testes Dev — Milky Moo Palmares" },
      {
        name: "description",
        content: "Área de testes e ferramentas de desenvolvimento do sistema.",
      },
      { property: "og:title", content: "Testes Dev — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Área de testes e ferramentas de desenvolvimento do sistema.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: TestesDevPage,
});
